import { useSyncExternalStore } from "react";
import {
  isCartSyncSettled,
  subscribeCartSyncSettled,
} from "@/libs/cart/server-cart-sync-state";

/**
 * 서버 카트 반영이 끝났는가 — GE 바스켓 표식(`data-ge-basket-*`)을 붙여도 되는가.
 * 판정·근거·수명은 `@/libs/cart/server-cart-sync-state` docblock.
 *
 * SSR 은 「끝」(true)으로 본다 — 서버엔 대기 중인 반영이 없고, 종전처럼 표식을 붙인 HTML 을 내야 하이드레이션 첫 렌더와 맞는다.
 */
export function useCartSyncSettled(): boolean {
  return useSyncExternalStore(
    subscribeCartSyncSettled,
    isCartSyncSettled,
    () => true,
  );
}
